import React from "react";

const ASP_Conditionals = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP Conditionals</h1>
      <p>This is the ASP Conditionals page content.</p>
    </div>
  );
};

export default ASP_Conditionals;
